var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.973 19.688a11.56 11.56 0 0 0-5.698-4.99 7.126 7.126 0 1 0-8.55 0 11.57 11.57 0 0 0-5.698 4.99 1.125 1.125 0 1 0 1.947 1.125c1.699-2.937 4.699-4.688 8.026-4.688s6.327 1.752 8.026 4.688a1.125 1.125 0 0 0 1.947-1.125M7.125 9a4.875 4.875 0 1 1 9.75 0 4.875 4.875 0 0 1-9.75 0"
  })));
};
export default SvgUser;